import { IndustryModuleCode } from './../../../../model/industry';
import { SubscriptionProductRelease } from './../../../../model/subscription';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { CmsService } from 'src/app/core/services/cms.service';
import { ImportExportService } from 'src/app/core/services/import-export.service';
import { MiniStorageService } from 'src/app/core/services/mini-storage.service';
import { ImportDataBodyContent, ImportDataParameters, ImportExportConsts } from 'src/app/database/helpers/database-helpers';
import { DbInfoBag } from 'src/app/database/helpers/db-info-bag';
import { CmsObject } from 'src/app/model/cmsobject';
import { QuickNoteLevels } from 'src/app/model/ImportExportManagement';
import { AppSubscription, SubscriptionToken } from 'src/app/model/subscription';
import { SubscriptionDatabase } from 'src/app/model/subscriptionDatabase';
import { AlertDialogComponent } from 'src/app/store/dialogs/alert-dialog/alert-dialog.component';
import { ReturnCodes } from 'src/app/pages/change-password/ReturnCodes';
import { LoadingService } from 'src/app/core/services/loading.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { LoginService } from 'src/app/core/services/login.service';
import { StepperOrientation } from '@angular/material/stepper';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { ChecklistDatabase, ImpExpTreeNode } from '../check-list-database';
import { SelectionModel } from '@angular/cdk/collections';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { SubscriptionService } from 'src/app/core/services/subscription.service';

@Component({
  selector: 'ms-import-management',
  templateUrl: './import-management.component.html',
  styleUrls: ['./import-management.component.scss'],
  providers: [ChecklistDatabase],
})
export class ImportManagementComponent implements OnInit {
  favoriteImport: string;
  favoriteDeleteOption: boolean = false;
  favoriteOverwriteOption: string;
  favoriteConfigurationOption: string;
  favoriteCountryOption: string;
  showCountrySectionDEFAULT = false;
  showCountrySectionSAMPLEDATA = false;
  selectFilesToImport: boolean = false;
  showSelectFilesToImport: boolean = false;

  stepperOrientation: Observable<StepperOrientation>;
  uploadMessage: string;

  showProcessStarted = false;
  showListFiles = false;
  showMore = false;

  subSelected: AppSubscription;
  @Input() subKeySelected: string;
  @Input() subDescriSelected: string;
  dbInfoBag: DbInfoBag;

  @ViewChild('stepper', { static: false }) myStepper: MatHorizontalStepper;

  importKey: string;
  countFilesToImport = 0;
  logs: string;
  // import options
  importParams: ImportDataParameters;
  isImporting = false;

  public loading: boolean = false;

  countries: Array<{ name: string; value: string }> = [];
  selectedCountry: { name: string; value: string } = {
    name: ImportExportConsts.INTL,
    value: ImportExportConsts.INTL,
  };
  // lista configurazioni disponibili per i dati di default/esempio
  configurations: Array<{ name: string; value: string }> = [];
  selectedConfiguration: { name: string; value: string } = {
    name: ImportExportConsts.BASIC,
    value: ImportExportConsts.BASIC,
  };

  noteLevel: QuickNoteLevels = QuickNoteLevels.Info;
  noteTitle = 'Import data has been started';
  noteText =
    'This process has been started and it may take a few minutes to complete. You will receive a notification when the operation will be done.';

  authorizationStored = this.loginService.getauthinfo();
  authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);

  public mng_impexp_title: string;
  public mng_impexp_descri: string;
  public cmsObj: CmsObject[];
  language: string;

  isStepComplete: boolean = false;

  // variables to manager files list tree
  TREE_DATA_local: any = undefined;
  favoriteTreeView = false;

  filesSelectedList: ImpExpTreeNode[] = [];

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  flatNodeMap = new Map<ImpExpTreeNode, ImpExpTreeNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  nestedNodeMap = new Map<ImpExpTreeNode, ImpExpTreeNode>();

  /** A selected parent node to be inserted */
  selectedParent: ImpExpTreeNode | null = null;

  /** The new item's name */
  newItemName = '';

  treeControl: FlatTreeControl<ImpExpTreeNode>;

  treeFlattener: MatTreeFlattener<ImpExpTreeNode, ImpExpTreeNode>;

  dataSource: MatTreeFlatDataSource<ImpExpTreeNode, ImpExpTreeNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<ImpExpTreeNode>(true /* multiple */);

  // Transformer to convert nested node to flat node. Record the nodes in maps for later use.
  transformer = (node: ImpExpTreeNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.name === node.name ? existingNode : new ImpExpTreeNode();
    flatNode.name = node.name;
    flatNode.fullPath = node.fullPath;
    flatNode.level = level;
    flatNode.expandable = !!node.children?.length;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };
  //

  // --------------------------------------------------------------------------
  constructor(
    private importExportService: ImportExportService,
    private workFlow: WorkFlowService,
    private loginService: LoginService,
    private subscriptionService: SubscriptionService,
    private variable: TranslatedVariables,
    public cmsService: CmsService,
    private miniStorage: MiniStorageService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private router: Router,
    public loadingService: LoadingService,
    private breakpointObserver: BreakpointObserver,
    private _database: ChecklistDatabase
  ) {
    this.stepperOrientation = breakpointObserver
      .observe('(min-width: 1600px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));

    this.importParams = new ImportDataParameters();

    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<ImpExpTreeNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    _database.decodeLevelNr = 3;
    _database.dataChange.subscribe((data) => {
      this.dataSource.data = data;
    });
  }

  // --------------------------------------------------------------------------
  async ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params) {
        window.history.replaceState({}, '', `/import-export-home/import-data`);
      }
      this.subKeySelected = params.subKeySelected;
    });
    this.dbInfoBag = new DbInfoBag();

    this.miniStorage.get('imp-subkey-' + this.subKeySelected).subscribe((res) => {
      if (res !== undefined) {
        this.subSelected = res;
        this.subDescriSelected = res.Description;
        const subscriptionModel = new AppSubscription();
        subscriptionModel.SubscriptionKey = res.SubscriptionKey;
        subscriptionModel.SubscriptionToken = res.SubscriptionToken;
        subscriptionModel.Description = res.Description;
        this.dbInfoBag.SubscriptionModel = subscriptionModel;
      } else this.AlertSessionExpired();
    });
    await this.getCmsObj();
    // this.subKeySelected = undefined;

    const authorizationStored = this.loginService.getauthinfo();
    if (authorizationStored === null || authorizationStored === undefined) {
      alert('DatabaseHomeComponent: User must be logged in.');
      return;
    }
    this.authorizationProperties = JSON.parse(authorizationStored);
    // inizializzo account corrente
    this.dbInfoBag.AccountName = this.authorizationProperties.accountName;
    this.dbInfoBag.SubscriptionKey = this.subSelected.SubscriptionKey;

    this.favoriteOverwriteOption = 'OverwriteRecord';
    this.favoriteDeleteOption = false;

    // chiedo la versione di MagoCloud all'accountmanager per nascondere le opzioni di import singoli files xml
    const getVersion = this.subscriptionService.getVersionBySubscriptionKey(this.dbInfoBag.SubscriptionKey).subscribe(
      (getVersionResult) => {
        if (getVersionResult === null || getVersionResult === undefined) {
          console.log('ImportManagement getVersionResult is null');
          getVersion.unsubscribe();

          this.loading = false;
          this.loadingService.setLoading(this.loading);
          return;
        }

        if (getVersionResult.Result) {
          // check versione di MagoCloud
          let subVersion = SubscriptionProductRelease.create(getVersionResult.Content);

          // seleziono i singoli file xml solo dalla 2.1
          if (subVersion.Major > 2 || (subVersion.Major == 2 && subVersion.Minor >= 1)) this.showSelectFilesToImport = true;
        } else {
          this.logs =
            getVersionResult !== null ? getVersionResult.Message : 'An error occurred calling getVersionBySubscriptionKey';
          this.showSelectFilesToImport = false;
        }

        this.loading = false;
        this.loadingService.setLoading(this.loading);

        this.refreshFrame();
        this.isImporting = false;
        getVersion.unsubscribe();
      },
      (getVersionError: HttpErrorResponse) => {
        alert(getVersionError.message);

        this.showSelectFilesToImport = false;
        this.logs = getVersionError.message;
        this.isImporting = false;

        this.loading = false;
        this.loadingService.setLoading(this.loading);
        getVersion.unsubscribe();
      }
    );
  }

  // --------------------------------------------------------------------------
  public AlertSessionExpired() {
    let quotationDialog = this.dialog.open(AlertDialogComponent, {
      data: {
        Title: this.variable.sessionExpiredTitle,
        Message: this.variable.sessionExpiredMessage,
      },
    });

    quotationDialog.afterClosed().subscribe(async () => {
      this.router.navigate(['/import-export-home']);
    });
  }

  // load the list of configurations from filesystem
  // --------------------------------------------------------------------------
  public async loadConfigurations(dataType: string): Promise<boolean> {
    if (this.subSelected === undefined || this.dbInfoBag === undefined) {
      this.AlertSessionExpired();
    }
    let isoCountry = this.subSelected.SubscriptionToken.country;

    if (isoCountry === undefined || isoCountry === '') {
      return false;
    }

    this.showCountrySectionDEFAULT = dataType === ImportExportConsts.DEFAULT;
    this.showCountrySectionSAMPLEDATA = dataType === ImportExportConsts.SAMPLE;

    this.loading = true;
    this.loadingService.setLoading(this.loading);

    //TODOROBY controllare se si sono già nella dbInfoBag
    return new Promise((resolve, reject) => {
      this.importExportService.getConfigurations(this.subSelected.SubscriptionKey, dataType, isoCountry).subscribe(
        (opRes) => {
          let response: boolean = false;
          if (!opRes['Result']) {
            this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            resolve(response);
            return false;
          }
          const configurationsRetrieved = opRes['Content'];
          if (configurationsRetrieved !== undefined && configurationsRetrieved !== null) {
            if (dataType === ImportExportConsts.DEFAULT) {
              this.dbInfoBag.defaultInfo = configurationsRetrieved;
              this.fillCountriesAndConfigurations();
            } else if (dataType === ImportExportConsts.SAMPLE) {
              this.dbInfoBag.sampleInfo = configurationsRetrieved;
              this.fillCountriesAndConfigurations();
            }
          }
          this.loading = false;
          this.loadingService.setLoading(this.loading);
          response = true;
          resolve(response);
        },
        (error: HttpErrorResponse) => {
          if (error.message != null) {
            alert(error.message);
            reject(error.message);
          }
          this.loading = false;
          this.loadingService.setLoading(this.loading);
          this.clean();
          return false;
        }
      );
    });
  }

  // evento sui radio-btn checked
  // -----------------------------------------------------------------------------
  async importTypeRadioGroupSelectionChange() {
    this.showCountrySectionDEFAULT = false;
    this.showCountrySectionSAMPLEDATA = false;
    if (this.subKeySelected === undefined) {
      return;
    }
    if (this.favoriteImport === ImportExportConsts.DEFAULT) {
      await this.loadConfigurations(ImportExportConsts.DEFAULT);
    } else if (this.favoriteImport === ImportExportConsts.SAMPLE) {
      await this.loadConfigurations(ImportExportConsts.SAMPLE);
    }

    if (this.favoriteImport !== ImportExportConsts.CUSTOM) {
      this.removeFiles();
    }
  }

  // -----------------------------------------------------------------------------
  selectedCountryChange(countryCode: { name: string; value: string }) {
    this.configurations = [];

    if (countryCode === undefined || (!this.showCountrySectionDEFAULT && !this.showCountrySectionSAMPLEDATA)) {
      return;
    }

    let values: Array<string> = [];
    if (this.favoriteImport === ImportExportConsts.DEFAULT && this.dbInfoBag?.defaultInfo !== undefined) {
      // if ((this.defaultRB.checked || this.optionalDefaultRB.checked) && this.dbInfoBag?.defaultInfo !== undefined) {
      for (const key in this.dbInfoBag?.defaultInfo) {
        if (key === countryCode.value) {
          values = this.dbInfoBag?.defaultInfo[key];
        }
      }
    } else if (this.favoriteImport === ImportExportConsts.SAMPLE && this.dbInfoBag?.sampleInfo !== undefined) {
      for (const key in this.dbInfoBag?.sampleInfo) {
        if (key === countryCode.value) {
          values = this.dbInfoBag?.sampleInfo[key];
        }
      }
    } else {
      alert('selectedCountryChange is undefined!');
      return;
    }

    for (let index = 0; index < values.length; index++) {
      const item = values[index];

      if (
        this.dbInfoBag.SubscriptionModel.SubscriptionToken.industryCode.toLocaleUpperCase() !== IndustryModuleCode.ADSP &&
        item.toLocaleUpperCase().startsWith(IndustryModuleCode.ADSP)
      )
        continue; // skippo le configurazioni ADSP se l'industry e' diversa

      this.configurations.push({ name: item, value: item });
    }

    // mi posiziono sulla prima configurazione se esiste
    this.selectedConfiguration = this.configurations.length > 0 ? { ...this.configurations[0] } : { name: '', value: '' };
    this.favoriteCountryOption = countryCode.value;
  }

  // -----------------------------------------------------------------------------
  public uploadFiles = (files: File[]) => {
    this.uploadMessage = '';

    if (files.length === 0) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          Title: 'Import data',
          Message: 'No file selected',
        },
      });
      this.countFilesToImport = 0;
      return;
    }

    const filesToUpload: File[] = files;
    const formData = new FormData();

    this.countFilesToImport = 0;

    let totSize = 0;

    Array.from(filesToUpload).map((file, index) => {
      if (file.name.toLowerCase().endsWith('zip')) {
        this.countFilesToImport = this.countFilesToImport + 1;
        totSize += file.size;
        return formData.append('file' + index, file, file.name);
      }
    });

    if (this.countFilesToImport === 0) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          Title: 'Import data',
          Message: 'Please choose a file in zip format',
        },
      });
      return;
    }

    console.log('Zip file length is: ' + totSize + ' bytes');
    // se la size del file zip e' superiore a 100 MB visualizzo un warning e non procedo
    if (totSize > 100000000) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          Title: 'Import data',
          Message: 'Importing a file larger than 100 MB is not permitted',
        },
      });
      return;
    }

    this.loading = true;
    this.loadingService.setLoading(this.loading);

    console.log('Import custom data: ' + this.countFilesToImport + ' files uploaded');
    this.uploadMessage = 'Upload is starting...';

    const upload = this.importExportService.uploadFiles(this.dbInfoBag.SubscriptionKey, formData).subscribe(
      (uploadRes) => {
        if (uploadRes.Result) {
          if (uploadRes.Code === ReturnCodes.OK) {
            this.importKey = uploadRes.Message;
            console.log('Import custom key: ' + uploadRes.Message);
            this.uploadMessage = 'File ' + files[0].name + ' successfully uploaded.';
          }
        } else {
          this.importKey = '';

          if (uploadRes.Code === 97) {
            // this code means ServiceNotResponding
            this.uploadMessage = 'Unable to upload files because the Microservice DB Management is not responding';
            this.dialog.open(AlertDialogComponent, {
              data: {
                Title: 'Upload file',
                Message: uploadRes.Message,
              },
            });
          } else {
            this.uploadMessage = uploadRes.Message;
          }
          console.log('Import custom data message: ' + uploadRes.Message);
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);

        upload.unsubscribe();
      },
      (error: HttpErrorResponse) => {
        this.importKey = '';
        console.log('Import custom data error: ' + error.message);
        this.loading = false;
        this.loadingService.setLoading(this.loading);
        upload.unsubscribe();
      }
    );
  };

  // -----------------------------------------------------------------------------
  async removeFiles() {
    this.loading = true;
    this.loadingService.setLoading(this.loading);
    this.countFilesToImport = 0;
    this.uploadMessage = undefined;
    this.loading = false;
    this.loadingService.setLoading(this.loading);
  }

  // -----------------------------------------------------------------------------
  setConfig(element: any) {
    this.favoriteConfigurationOption = element;
  }

  // -----------------------------------------------------------------------------
  setCountry(element: any) {
    this.favoriteCountryOption = element;
  }

  // -----------------------------------------------------------------------------
  doImportData() {
    this.isStepComplete = true;

    if (this.isImporting) {
      this.dialog.open(AlertDialogComponent, {
        data: {
          Title: 'Import data',
          Message: 'Elaboration in progress, please wait for its completion',
        },
      });
      return;
    }

    // check valori inseriti prima di avviare la procedura
    if (!this.checkInputValuesBeforeImport()) {
      return;
    }

    this.loading = true;
    this.loadingService.setLoading(this.loading);

    this.importParams.NoOptional = this.favoriteImport !== 'optionaldefault';
    this.importParams.OverwriteRecord = this.favoriteOverwriteOption === 'OverwriteRecord';
    this.importParams.DeleteTableContext = this.favoriteDeleteOption;

    // fill values in class to sent to back-end in the body
    const importBodyContent: ImportDataBodyContent = new ImportDataBodyContent();
    if (this.dbInfoBag.SubscriptionDatabaseModel === null || this.dbInfoBag.SubscriptionDatabaseModel === undefined) {
      let r = new SubscriptionDatabase();
      r.SubscriptionKey = this.dbInfoBag.SubscriptionKey;
      r.InstanceKey = this.authorizationProperties.currentInstanceKey;
      this.dbInfoBag.SubscriptionDatabaseModel = r;
    }
    importBodyContent.Database = this.dbInfoBag.SubscriptionDatabaseModel;
    importBodyContent.ImportParameters = this.importParams;
    // add any selected files to the list
    this.filesSelectedList.forEach((file) => {
      importBodyContent.Files.push(file.fullPath);
    });

    const authorizationStored = this.loginService.getauthinfo();
    if (authorizationStored !== null && authorizationStored !== undefined) {
      const authorizationProperties: AuthorizationProperties = JSON.parse(authorizationStored);
      // propago l'AccountName
      importBodyContent.AccountName = authorizationProperties.accountName;
    }

    importBodyContent.Country = this.favoriteCountryOption;
    importBodyContent.Edition = 'Professional'; // this.dbInfoBag.SubscriptionModel.SubscriptionToken.edition
    importBodyContent.Configuration = this.favoriteConfigurationOption;
    importBodyContent.ConfigurationType = this.favoriteImport;
    if (this.favoriteImport === 'custom') {
      // nuova gestione con concatenazione rediskey + webdavkey lato backend
      const keys: Array<string> = this.importKey?.split(';');
      if (keys !== undefined) {
        importBodyContent.ImportKey = keys[0];
        if (keys.length > 1) {
          importBodyContent.ImportExportKey = keys[1];
        }
      } else {
        this.importKey = '';
      }
    }

    // se ho scelto i dati opzionali valorizzo d'ufficio la country della sub
    if (this.favoriteImport === 'optionaldefault') {
      importBodyContent.Configuration = ImportExportConsts.BASIC;
      importBodyContent.Country = this.dbInfoBag.SubscriptionModel.SubscriptionToken.country;
    }

    this.isImporting = true;
    this.showProcessStarted = true;

    // importazione da file default/esempio
    const importData = this.importExportService.importData(this.dbInfoBag.SubscriptionKey, importBodyContent).subscribe(
      (importDataResult) => {
        this.myStepper.next();
        if (importDataResult === null || importDataResult === undefined) {
          console.log('ImportManagement importDataResult is null');
          importData.unsubscribe();

          this.loading = false;
          this.loadingService.setLoading(this.loading);
          return;
        }

        if (!importDataResult.Result) {
          this.logs = importDataResult !== null ? importDataResult.Message : 'An error occurred calling ImportData';
        }

        this.loading = false;
        this.loadingService.setLoading(this.loading);

        //  this.logs = importDataResult.Message;
        this.refreshFrame();
        this.isImporting = false;
        importData.unsubscribe();
      },
      (importDataError: HttpErrorResponse) => {
        alert(importDataError.message);
        this.logs = importDataError.message;
        this.isImporting = false;

        this.loading = false;
        this.loadingService.setLoading(this.loading);
        importData.unsubscribe();
      }
    );
  }

  grafanaLogsExtracted: string[];
  // -----------------------------------------------------------------------------
  async refreshFrame() {
    let v = await this.getSrc();
    this.grafanaLogsExtracted = v.Content as string[];
  }

  // -----------------------------------------------------------------------------
  async getSrc() {
    const getLogsRes = await this.importExportService.getGrafanaLogsToPromise(
      this.dbInfoBag.SubscriptionKey,
      this.dbInfoBag.AccountName
    );
    if (getLogsRes === null || getLogsRes === undefined) {
      console.log('getGrafanaLogs: getLogsRes is null');
      return null;
    }

    if (!getLogsRes.Result) {
      this.logs = getLogsRes !== null ? getLogsRes.Message : 'An error occurred calling ImportData';
    }

    return getLogsRes;
  }

  // -----------------------------------------------------------------------------
  checkInputValuesBeforeImport(): boolean {
    if (this.favoriteImport === 'custom') {
      let msg: string;
      if (this.countFilesToImport === 0) {
        msg = 'No valid uploaded file available. Unable to proceed';
        this.dialog.open(AlertDialogComponent, {
          data: {
            Title: 'Import data',
            Message: msg,
          },
        });
        console.log(msg);
        return false;
      }

      if (this.importKey === undefined || this.importKey === '') {
        msg = 'No uploaded file available (ImportKey not valid). Unable to proceed';
        this.dialog.open(AlertDialogComponent, {
          data: {
            Title: 'Import data',
            Message: msg,
          },
        });
        console.log(msg);
        return false;
      }
    } else if (this.favoriteConfigurationOption === '' || this.favoriteCountryOption === '') {
      this.dialog.open(AlertDialogComponent, {
        data: {
          Title: 'Import data',
          Message: 'Country or configuration are missing!',
        },
      });
      return false;
    }

    return true;
  }

  // -----------------------------------------------------------------------------
  fillCountriesAndConfigurations() {
    this.countries = [];

    // if (this.dbInfoBag === undefined) {
    //     alert('dbInfoBag is undefined! ic');
    //     this.miniStorage.get(this.subKeySelected + '-DbInfoBag').subscribe((res) => {
    //         if (res !== undefined) {
    //             this.dbInfoBag = res;
    //         }
    //     });
    //     return;
    // }

    if (
      this.dbInfoBag.SubscriptionModel?.SubscriptionToken?.country !== null &&
      this.dbInfoBag.SubscriptionModel?.SubscriptionToken?.country !== undefined
    ) {
      this.countries.push(
        // la country e' un'informazione di subscription
        {
          name: this.dbInfoBag.SubscriptionModel?.SubscriptionToken?.country,
          value: this.dbInfoBag.SubscriptionModel?.SubscriptionToken?.country,
        }
      );

      this.selectedCountry = { ...this.countries[0] };
    }

    // il set INTL viene aggiunto d'ufficio
    this.countries.push({ name: 'INTL', value: 'INTL' });
    if (this.selectedCountry === undefined) {
      this.selectedCountry = { ...this.countries[0] };
    }

    this.configurations = [];

    this.selectedCountryChange(this.selectedCountry);
    this.selectedConfigurationChange(this.selectedConfiguration);
  }

  // -----------------------------------------------------------------------------
  selectedConfigurationChange(config: { name: string; value: string }) {
    this.favoriteConfigurationOption = config.value;
  }

  // -----------------------------------------------------------------------------
  getYesOrNoOptionUnique(favoriteOption: any) {
    if (favoriteOption === true || favoriteOption === 'OverwriteRecord') return this.variable.yes;
    else if (favoriteOption === false || favoriteOption === 'NoOverwriteRecord') return this.variable.no;
  }

  // -----------------------------------------------------------------------------
  getFavoriteImport(favoritImport: string) {
    switch (favoritImport) {
      case 'default':
        return this.variable.imp_exp_default_data;
      case 'optionaldefault':
        return this.variable.imp_exp_default_Optional_data;
      case 'sample':
        return this.variable.imp_exp_sample_data;
      case 'custom':
        return this.variable.imp_exp_upload_file;
    }
  }

  // -----------------------------------------------------------------------------
  async getCmsObj() {
    this.language = this.workFlow.getLanguageForCms();
    //recupero le stringhe della pagina
    this.cmsObj = await this.cmsService.getCmsObj(this.language, 'accountcomponent');
    this.mng_impexp_title = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_title')?.ContentTranslation;
    this.mng_impexp_descri = this.cmsObj.find((x) => x.ContentName == 'accountcomponent.mng_impexp_descri')?.ContentTranslation;
  }

  // -----------------------------------------------------------------------------
  clean() {
    this.favoriteImport = null;
    this.favoriteCountryOption = null;
    this.favoriteConfigurationOption = null;
    this.favoriteDeleteOption = null;
    this.favoriteOverwriteOption = null;
    this.dbInfoBag = null;
    this.showProcessStarted = false;
    this.isStepComplete = false;
    this.filesSelectedList = [];

    // this.ngOnInit();
    this.router.navigate(['/import-export-home']);
  }

  // -----------------------------------------------------------------------------
  loadFiles() {
    if (!this.selectFilesToImport) return;

    this.showListFiles = true;

    if (this.TREE_DATA_local === undefined) {
      this.loading = true;
      this.loadingService.setLoading(this.loading);
      let opRes = this.importExportService
        .getFilesListAppsMods(
          this.subKeySelected,
          this.favoriteImport,
          this.favoriteCountryOption,
          this.favoriteConfigurationOption
        )
        .subscribe(
          (opRes) => {
            this.myStepper.next();
            if (!opRes['Result']) {
              this.workFlow.showMessage(this.variable.errorTitle, opRes['Message']);
              this.loading = false;
              this.loadingService.setLoading(this.loading);
              this.myStepper.previous();
              return;
            }
            let listOfAM = opRes['Content'];

            if (listOfAM !== '') {
              try {
                let r: ImpExpTreeNode[] = JSON.parse(listOfAM);
                const data = this._database.buildFileTree(r, 0);
                this.TREE_DATA_local = data;
                this.loading = false;
                this.loadingService.setLoading(this.loading);
                // Notify the change.
                this._database.dataChange.next(data);
              } catch (exc) {
                console.log(exc);
                return;
              }
            }
          },
          (err: HttpErrorResponse) => {
            this.workFlow.showMessage(this.variable.errorTitle, err.message);
            this.loading = false;
            this.loadingService.setLoading(this.loading);
            this.clean();
            opRes.unsubscribe();
          }
        );
    }
  }

  // per gestire il summary con la lista dei files
  // -----------------------------------------------------------------------------
  getFilesList(index: number) {
    this.filesSelectedList = [];
    if (index !== 0) {
      this.filesSelectedList = this.checklistSelection.selected.filter((u) => u.level === index);
    }
    return this.filesSelectedList;
  }

  // -----------------------------------------------------------------------------
  public hideDetails(fragment: string) {
    this.showMore = false;
    if (!document.getElementById(fragment)) return;
    document.getElementById(fragment).className = 'line-clamp';
  }

  // -----------------------------------------------------------------------------
  public showDetails(fragment: string) {
    this.showMore = true;
    if (!document.getElementById(fragment)) return;
    document.getElementById(fragment).className = '';
  }

  // -----------------------------------------------------------------------------
  changeFavExport() {
    this.checklistSelection = new SelectionModel<ImpExpTreeNode>(true /* multiple */);
  }

  getLevel = (node: ImpExpTreeNode) => node.level;

  isExpandable = (node: ImpExpTreeNode) => node.expandable;

  getChildren = (node: ImpExpTreeNode): ImpExpTreeNode[] => node.children;

  hasChild = (_: number, _nodeData: ImpExpTreeNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: ImpExpTreeNode) => _nodeData.name === '';

  /** Whether all the descendants of the node are selected. */
  // -----------------------------------------------------------------------------
  descendantsAllSelected(node: ImpExpTreeNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every((child) => {
        return this.checklistSelection.isSelected(child);
      });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  // -----------------------------------------------------------------------------
  descendantsPartiallySelected(node: ImpExpTreeNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  // -----------------------------------------------------------------------------
  todoItemSelectionToggle(node: ImpExpTreeNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach((child) => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  // check on single table
  // -----------------------------------------------------------------------------
  todoLeafItemSelectionToggle(node: ImpExpTreeNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  // -----------------------------------------------------------------------------
  filterChanged(filterText: string) {
    this._database.filter(filterText, this.TREE_DATA_local);
    if (filterText) {
      this.treeControl.expandAll();
    } else {
      this.treeControl.collapseAll();
    }
  }

  highlightStrings(filterText: string) { }

  /* Checks all the parents when a leaf node is selected/unselected */
  // -----------------------------------------------------------------------------
  checkAllParentsSelection(node: ImpExpTreeNode): void {
    let parent: ImpExpTreeNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  // check on module node
  // -----------------------------------------------------------------------------
  checkRootNodeSelection(node: ImpExpTreeNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every((child) => {
        return this.checklistSelection.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  // -----------------------------------------------------------------------------
  getParentNode(node: ImpExpTreeNode): ImpExpTreeNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /** Select the category so we can insert the new item. */
  // -----------------------------------------------------------------------------
  addNewItem(node: ImpExpTreeNode) {
    const parentNode = this.flatNodeMap.get(node);
    this._database.insertItem(parentNode!, '');
    this.treeControl.expand(node);
  }

  /** Save the node to database */
  // -----------------------------------------------------------------------------
  saveNode(node: ImpExpTreeNode, itemValue: string) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(nestedNode!, itemValue);
  }

  // -----------------------------------------------------------------------------
  collapseExpandChange() {
    if (!this.favoriteTreeView) this.treeControl.expandAll();
    else this.treeControl.collapseAll();
    this.favoriteTreeView = !this.favoriteTreeView;
  }
}
